(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.hdrReady) return;
      root.dataset.hdrReady = '1';

      var drawer = root.querySelector('.hdr-drawer');
      var overlay = root.querySelector('.hdr-overlay');
      var openBtn = root.querySelector('[data-hdr-open]');
      var searchPanel = root.querySelector('.hdr-search');
      var searchBtns = root.querySelectorAll('[data-hdr-search-toggle]');
      var searchInput = root.querySelector('.hdr-search__input');

      function setDrawer(open) {
        drawer.classList.toggle('is-open', open);
        drawer.setAttribute('aria-hidden', String(!open));
        overlay.hidden = !open;
        if (openBtn) openBtn.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      }
      function setSearch(open) {
        searchPanel.hidden = !open;
        searchBtns.forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
        if (open && searchInput) searchInput.focus();
      }

      if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
      root.querySelectorAll('[data-hdr-close]').forEach(function (el) {
        el.addEventListener('click', function () { setDrawer(false); });
      });
      searchBtns.forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); setSearch(searchPanel.hidden); });
      });
      var searchClose = root.querySelector('[data-hdr-search-close]');
      if (searchClose) searchClose.addEventListener('click', function () { setSearch(false); });

      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        setDrawer(false);
        setSearch(false);
      });

      var bubble = root.querySelector('[data-hdr-cart-count]');
      function refreshCart() {
        if (!bubble) return;
        fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { bubble.textContent = cart.item_count; bubble.hidden = cart.item_count === 0; })
          .catch(function () {});
      }
      window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
      document.addEventListener('cart:refresh', refreshCart);

      var cartLink = root.querySelector('[data-hdr-cart]');
      if (cartLink) {
        cartLink.addEventListener('click', function (e) {
          var cd = document.querySelector('cart-drawer');
          if (cd && typeof cd.open === 'function') { e.preventDefault(); cd.open(cartLink); }
        });
      }
      window.addEventListener('load', function () {
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCart);
        }
      });
    }

    document.querySelectorAll('[data-hdr]').forEach(init);
    document.addEventListener('shopify:section:load', function () {
      document.querySelectorAll('[data-hdr]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
